import {Typography} from "@mui/material";

export const CsInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Dashboards',
                content: 'This is a list of the Dashboards that can be run to generate fresh data using the menu to the left.  ' +
                    'Create a new Dashboard, give it a name, then add Filtering Criteria to decide what records to include, ' +
                    'and add Data Points to determine what data to include in the Dashboard. '
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contract Sections',
                content: (
                    <>
                        <Typography paragraph>
                            Contract Sections provide the structure
                            inside a contract.
                        </Typography>

                        <ul>
                            <li>
                                The system reads through the
                                Contract Sections in the order
                                they are listed.
                            </li>

                            <li>
                                Contract Sections can be nested
                                and branched to create complex
                                structures.
                            </li>

                            <li>
                                If access is denied to a
                                Contract Section, access to
                                all of its children will
                                also be denied.
                            </li>

                            <li>
                                Contract Sections can be moved
                                and their nesting changed,
                                but this must be done with caution.
                            </li>

                            <li>
                                Structural changes can affect
                                how the system reads through
                                the Contract Sections.
                            </li>

                            <li>
                                For true contracts,
                                Contract Sections should replicate
                                the structure of the relevant
                                sections of the source contract.
                            </li>
                        </ul>
                    </>
                )
            }
            //     content: 'Contract Sections provide the structure inside a contract.  ' +
            //         'The system reads through the Contract Sections in the order they are listed. ' +
            //         'They can be nested and branched to create complex structures.  If access is denied to a Contract Section, ' +
            //         'access to all of its children will be denied.  ' +
            //         'Contract Sections can be moved and their nesting changed, but this must be done with caution ' +
            //         'because it can affect how the system reads through the Contract Sections.  ' +
            //         'For true contracts, Contract Sections should replicate the structure of the relevant sections of the source contract.  '
            // };

    }

};